/* eslint-disable */
import {AfterViewInit, Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Observable} from 'rxjs';
import {DialogType} from '@pt/pt-models';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AsyncPipe, NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'pt-confirm-dialog',
  standalone: true,
  template: `
    <div class='modal-header'
         (click)='$event.stopPropagation()'>
      <h4 class='modal-title'>
        {{ title | async }}
      </h4>
    </div>

    <div class='modal-body' (click)='$event.stopPropagation()'>
      <p [innerHTML]='message | async'></p>

      <ng-container *ngIf="subMessage">
        <p style="color: #646464" *ngFor="let sub of subMessage" [innerHTML]="sub| async"></p>
      </ng-container>

      <ng-container *ngIf="customTemplate">
        <ng-template [ngTemplateOutlet]="customTemplate"></ng-template>
      </ng-container>

      <div class='form-group mt-3' *ngIf='validation && TEXT_FOR_DELETE else LOADING'>
        <label class='form-check-label' for='insertTextToConfirm'
               [innerHTML]="'MESSAGE.TYPE_DELETE_TO_CONFIRM' | translate: { value: TEXT_FOR_DELETE } ">
        </label>
        <input class='form-control' type='text' [(ngModel)]='confirmMessage' id='insertTextToConfirm'>
      </div>

      <ng-template #LOADING>
        <ng-container *ngIf="validation">
          <div class="spinner-border spinner-border-sm" role="status"></div>
          <span class="ms-1">Loading...</span>
        </ng-container>
      </ng-template>

    </div>

    <div class='modal-footer' (click)='$event.stopPropagation()'
         *ngIf="dialogType === DT.DELETE || dialogType === DT.MESSAGE">
      <button type='button' class='btn btn-danger btn-sm'
              [disabled]='validation && confirmMessage !== TEXT_FOR_DELETE'
              (click)='activeModal.close(true); $event.stopPropagation()'
              *ngIf='dialogType === DT.DELETE'>
        <ng-container *ngIf="customConfirmBtnLabel">
          {{ customConfirmBtnLabel | async }}
        </ng-container>
        <ng-container *ngIf="!customConfirmBtnLabel">
          {{ 'BUTTON.DELETE' | translate }}
        </ng-container>
      </button>
      <button type='button' class='btn btn-primary btn-sm'
              [disabled]='validation && confirmMessage !== TEXT_FOR_DELETE'
              (click)='activeModal.close(true); $event.stopPropagation()'
              *ngIf='dialogType === DT.MESSAGE'>
        {{ customConfirmBtnLabel ? (customConfirmBtnLabel | async) : ('BUTTON.CONFIRM' | translate) }}
      </button>
      <button ngbAutofocus type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ 'BUTTON.CANCEL' | translate }}
      </button>
    </div>

    <div class='modal-footer'
         (click)='$event.stopPropagation()'
         *ngIf='dialogType === DT.MESSAGE_SUCCESS || dialogType === DT.MESSAGE_FAILED'>
      <button type='button' class='btn btn-outline-secondary btn-sm'
              (click)='activeModal.close(false); $event.stopPropagation()'>
        {{ customConfirmBtnLabel ? (customConfirmBtnLabel | async) : ('BUTTON.CLOSE' | translate) }}
      </button>
    </div>
  `,
  imports: [
    AsyncPipe,
    NgTemplateOutlet,
    NgIf,
    NgForOf,
    TranslateModule,
    FormsModule
  ],
  styles: [``]
})
export class ConfirmDialogComponent implements AfterViewInit {
  //todo try to remove validation?
  @Input() validation = false;

  @Input() dialogType!: DialogType;
  @Input() textToValidate?: string;
  @Input() title!: Observable<string>;
  @Input() message!: Observable<string>;
  @Input() subMessage?: Observable<string>[];
  @Input() customConfirmBtnLabel?: Observable<string>;
  @Input() customTemplate: any;

  public TEXT_FOR_DELETE?: string;
  public confirmMessage?: string;
  public DT = DialogType;

  constructor(public activeModal: NgbActiveModal, private translateService: TranslateService) {
  }

  ngAfterViewInit() {
    const timeout = setTimeout(() => {
      if (this.textToValidate) {
        this.TEXT_FOR_DELETE = this.textToValidate;
      } else {
        this.translateService.stream('MESSAGE.DELETE_TO_CONFIRM_VALUE').subscribe({
          next: (message) => {
            this.TEXT_FOR_DELETE = message;
          }, error: () => {
            this.TEXT_FOR_DELETE = 'DELETE'
          }
        });
      }
      clearTimeout(timeout);
    }, 300)
  }

}

